import logoImage from "../../assets/images/logo.png";
import logoWhiteImage from "../../assets/images/logo-white.png";

/**
 * Logo Component
 *
 * Displays the application logo with different variants and sizes
 * Supports both regular and white versions for different backgrounds
 * Falls back to text logo if images are not available
 */
const Logo = ({
  variant = "default", // "default" | "white" | "text-only"
  size = "medium", // "small" | "medium" | "large" | "custom"
  className = "",
  onClick = null,
  alt = "MirtSew Logo",
}) => {
  const getSizeClass = () => {
    switch (size) {
      case "small":
        return "logo-small";
      case "large":
        return "logo-large";
      case "custom":
        return "";
      default:
        return "logo-medium";
    }
  };

  const getLogoSrc = () => {
    switch (variant) {
      case "white":
        return logoWhiteImage;
      case "text-only":
        return null;
      default:
        return logoImage;
    }
  };

  const logoClasses = `logo ${getSizeClass()} ${className}`.trim();
  const logoSrc = getLogoSrc();

  // Show text logo if variant is text-only or if images are not available
  if (variant === "text-only" || !logoSrc) {
    return (
      <div
        className={`logo-text ${logoClasses}`}
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        MirtSew
      </div>
    );
  }

  return (
    <div className={logoClasses}>
      <img
        src={logoSrc}
        alt={alt}
        className="logo-image"
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
        onError={(e) => {
          // Fallback to text if image fails to load
          e.target.style.display = "none";
          const textFallback = document.createElement("div");
          textFallback.className = "logo-text-fallback";
          textFallback.textContent = "MirtSew";
          textFallback.style.cursor = onClick ? "pointer" : "default";
          if (onClick) {
            textFallback.onclick = onClick;
          }
          e.target.parentElement.appendChild(textFallback);
        }}
      />
    </div>
  );
};

export default Logo;
